import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Stack, Typography } from "@mui/material";
import { FACEBOOK_LINK_PROFILE, INSTAGRAM_LINK_PROFILE, LINKEDIN_LINK_PROFILE, TWITTER_LINK_PROFILE } from "app/appConstants";
import { MprcContainer, MprcIconButton } from "components";
import { UserProfileDto, UserSocialNetworkDto, UserSocialNetworkType } from "generated/CoreApi_v1";
import React from "react";
import { useTranslation } from "react-i18next";
import { getSocialNetworkIcon } from "views/foundation/user/Home/EditProfile/EditUserPersonInfoBox";

interface IProps {
    user: UserProfileDto;
}

/**
 * Painel lateral de redes sociais.
 * @param props
 */
export const PanelUserSocialNetwork: React.FC<IProps> = (props) => {
    const { user } = props;
    const { t } = useTranslation("knowledge");

    ///
    const openLinkSocialNetwork = (item: UserSocialNetworkDto) => {
        if (!item.socialNetworkId) return;

        if (item.socialNetworkType == UserSocialNetworkType.Twitter)
            window.open(TWITTER_LINK_PROFILE + "/" + item.socialNetworkId, "");
        else if (item.socialNetworkType == UserSocialNetworkType.Facebook)
            window.open(FACEBOOK_LINK_PROFILE + "/" + item.socialNetworkId, "");
        else if (item.socialNetworkType == UserSocialNetworkType.Instagram)
            window.open(INSTAGRAM_LINK_PROFILE + "/" + item.socialNetworkId, "");
        else if (item.socialNetworkType == UserSocialNetworkType.Linkedin)
            window.open(LINKEDIN_LINK_PROFILE + "/" + item.socialNetworkId, "");
    };

    return user.socialNetworks.length > 0
        ? (
            <>
                <MprcContainer margin="dense">
                    <Typography variant="h3">{t("Feed.Panels.UserSocialNetwork.Title")}</Typography>
                </MprcContainer>

                <Stack direction="row" justifyContent="flex-start" alignContent="flex-start" flexWrap="wrap">
                    {
                        user
                            .socialNetworks
                            .filter(p => p.socialNetworkId != "")
                            .map((item, index) =>
                                <MprcIconButton
                                    key={index}
                                    title={item.socialNetworkTypeName}
                                    size="small"
                                    onClick={() => openLinkSocialNetwork(item)}
                                >
                                    <FontAwesomeIcon icon={getSocialNetworkIcon(item.socialNetworkType)} size="2x" fixedWidth />
                                </MprcIconButton>
                            )
                    }
                </Stack>
            </>
        )
        : null;
};
